import React from 'react';

interface StatusIndicatorProps {
  status?: string;
  reasons?: string[];
}

const pillClasses = (status?: string): string => {
  switch ((status || '').toLowerCase()) {
    case 'online':
      return 'bg-green-100 text-green-800';
    case 'offline':
      return 'bg-red-100 text-red-800';
    case 'maintenance':
      return 'bg-blue-100 text-blue-800';
    case 'pending':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-yellow-100 text-yellow-800';
  }
};

/**
 * Shows a device's health. When there's something wrong we list the specific
 * short reasons as bullets (e.g. "Temp 85C (over 80C)", "Content service offline")
 * instead of a bare "Warning" word. Otherwise a plain status pill.
 */
const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status, reasons }) => {
  if (reasons && reasons.length > 0) {
    return (
      <ul className="text-xs text-amber-700 font-medium space-y-0.5">
        {reasons.map((reason, i) => (
          <li key={i} className="flex items-start">
            <span className="mr-1 leading-none">•</span>
            <span>{reason}</span>
          </li>
        ))}
      </ul>
    );
  }

  // No specific reasons: show the plain status (never a bare "Warning").
  const label = (status || '').toLowerCase() === 'warning' ? 'Issue' : status || 'Unknown';
  return (
    <span className={`px-2 py-1 text-xs rounded-full font-medium ${pillClasses(status)}`}>
      {label}
    </span>
  );
};

export default StatusIndicator;
